import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ActivityTemplateFactory from "../../Entity/Factories/ActivityTemplateFactory";

export default function* activityTemplateList(action: ActionInterface): any {
  try {

    const res = yield call(Http.get, "activity-templates");

    const activityTemplates = res.data.map(activityTemplate => {
      return ActivityTemplateFactory.create(activityTemplate);
    });

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_LIST_SUCCESS,
      payload: {
        activityTemplates: activityTemplates
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchActivityTemplateList() {
  yield takeEvery(Constants.GLOBAL_ACTIVITY_TEMPLATE_LIST, activityTemplateList);
}
